import Quote from "./Quote/Quote"
import PersonalDetail from "./personalDetail/PersonalDetail";
import Income from './Income/Income';
import Assets from './Assets/Assets';
import Debts from './Debts/Debts';
import Expenses from './Expenses/Expenses';

export {Quote, PersonalDetail , Income, Assets, Debts, Expenses }